<template>
  <div>
    <div v-if="pluggyId">
      <Alert type="success">
        <span>
          Sua conta <b>ESTÁ</b> conectada ao Open Finance
        </span>
        <Button _key="btnDisconnect" classIcon="fa-solid fa-plug-circle-xmark" title="Desconectar"
          backGroundColor="var(--color-danger)" color="var(--text-inverse)" size="medium"
          :clicked="disconnectAccount" />
      </Alert>
    </div>

    <div v-else>
      <Alert type="info">
        <span>
          Conecte sua conta ao Open Finance e tenha <b>Integração Bancária Automática</b>
        </span>
        <Button _key="btnConnect" title="Conectar" classIcon="fa-solid fa-plug" backGroundColor="var(--color-brand)"
          color="var(--text-inverse)" size="medium" :clicked="getConnectToken" />
      </Alert>
    </div>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Alert from "@/ui/layout/Alert";

import BankAccountService from "../../services/bankAccount.service";

import { mapMutations } from "vuex";

export default {
  name: "PluggyConnect",
  props: ["pluggyId"],
  components: {
    Button, Alert
  },
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "removeLoading"]),
    async getConnectToken() {
      const response = await BankAccountService.getConnectToken();
      this.openPluggyConnect(response.content);
    },
    openPluggyConnect(connectToken) {
      this.removeLoading(["btnConnect"]);
      const pluggyConnect = new window.PluggyConnect({
        connectToken: connectToken,
        includeSandbox: false,
        onSuccess: (itemData) => {
          this.updateBankAccount(itemData.item.id);
        },
        onError: (error) => {
          console.error('Error:', error);
        },
      });
      pluggyConnect.init();
    },
    async updateBankAccount(itemId) {
      const response = await BankAccountService.updatePluggyId(this.id, itemId);
      if (response.success) {
        this.addEvent({ name: "pluggyUpdated" });
      }
    },
    async disconnectAccount() {
      const response = await BankAccountService.disconnectAccount(this.id);
      if (response.success) {
        this.addEvent({ name: "pluggyUpdated" });
      }
    },
  },
};
</script>
<style scoped></style>
